<template>
<span>
    <v-form ref="form" lazy-validation autocomplete="off">

        <v-container fluid>

            <v-row>

                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="d-flex">
                    <v-select small-chips item-value="usu_id" item-text="usu_nome" required outlined :rules="rules.usuario" v-model="users_selected" :items="loadUsersFuncionarios" :menu-props="{ maxHeight: '400' }" label="Usuários" multiple persistent-hint></v-select>
                    <v-col cols="12" xs="12" sm="12" md="4" lg="3" xl="2" class="d-flex flex-column pa-0">
                    <v-btn small color="lime" class="ml-6 btn-upload black--text" @click="selectAll">
                        Marcar Todos
                    </v-btn>
                    <v-btn small color="lime" class="mt-1 ml-6 btn-upload black--text" @click="deselectAll">
                        Desmarcar Todos
                    </v-btn>
                    </v-col>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="text-center">
                    <v-text-field v-model="download.down_nome" :rules="rules.nome" placeholder="Nome do Arquivo" required outlined></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="text-center">
                    <input type="file" ref="files" style="display:none;" accept="application/pdf,.doc,.xls,.docx,.xlsx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" id="files" @change="onFilesChange" />
                    <v-btn color="blue-grey" class="btn-upload white--text" @click="$refs.files.click()">
                        Adicionar Arquivos
                        <v-icon right dark>cloud_upload</v-icon>
                    </v-btn>
                </v-col>
                
            </v-row>

        </v-container>
    </v-form>

</span>
</template>

<script>
import {
    URL_BASE
} from '../../../../config/configs'

export default {
    name: "FormDownloadFileComponent",
    created() {
        this.$store.dispatch("loadUsersFuncionarios");
        this.down_nome = this.download.down_nome
    },
    computed: {
        loadUsersFuncionarios() {
            console.log(this.$store.state.users.func.data)
            if (this.$store.state.users.func.data == null)
                return []

            return this.$store.state.users.func.data;
        }
    },
    props: {
        download_category: null,
        download: {
            require: false,
            type: Object | Array,
            default: () => {
                return {
                    down_id: '',
                    download_category_id: '',
                    down_nome: '',
                    down_arquivo: '',
                    down_descricao: '',
                    down_status: '',
                }
            },
        },
        require: true,
        down_c_id: ''
    },
    data() {
        return {
            teste: null,
            users_selected: null,
            attachments: [],
            attachment: '',
            preview: null,
            base_url: URL_BASE,
            rules: {
                usuario: [
                    v => !!v || 'Campo Usuário é obrigatório'
                ],
                nome: [
                    v => !!v || 'Campo Texto é obrigatório',
                ]
            },
        }
    },
    methods: {

        selectAll() {
            // Copy all v-select's items in your selectedItem array
            this.users_selected = [...this.loadUsersFuncionarios]
        },

        deselectAll() {
            // Copy all v-select's items in your selectedItem array
            this.users_selected = []
        },

        onFilesSubmit() {

            if (this.$refs.form.validate()) {
                const formData = new FormData();

                for (let i = 0; i < this.attachments.length; i++) {
                    formData.append('arquivos[]', this.attachments[i]);
                }

                formData.append('down_id', this.download.down_id);
                formData.append('down_nome', this.download.down_nome);
                formData.append('download_category_id', this.download_category.down_c_id);
                formData.append('down_arquivo', this.download.down_arquivo);
                formData.append('down_descricao', this.download.down_descricao);
                formData.append('down_status', this.download.down_status);
                formData.append('users_selected', this.users_selected);

                this.attachments = [];
                document.getElementById('files').value = [];

                this.$store.dispatch('addFilesDownload', formData)
                    .then(() => {
                        this.$swal({
                            position: "center",
                            icon: "success",
                            title: 'Arquivo adicionado com sucesso',
                            showConfirmButton: true,
                            timer: 6000
                        });
                        this.$emit('atualizar');
                    })
                    .catch(error => {
                        this.$swal({
                            position: "center",
                            icon: "error",
                            title: 'Erro',
                            text: 'Algo deu errado',
                            showConfirmButton: true,
                            timer: 6000
                        });
                    })
            } else {
                this.$swal({
                    position: "center",
                    icon: "warning",
                    title: 'Alguns campos requer sua atenção',
                    text: 'Verifique os campos em vermelho',
                    showConfirmButton: true,
                    timer: 6000
                });
            }
        },
        onFilesChange(e) {
            let selectedFiles = e.target.files || e.dataTransfer.files;

            if (!selectedFiles.length)
                return;

            for (let i = 0; i < selectedFiles.length; i++) {
                this.attachments.push(selectedFiles[i]);
            }

            this.onFilesSubmit();

        },
    },
    components: {

    }
};
</script>

<style scoped>
.theme--dark.v-sheet {
    background-color: #303030;
    border-color: #303030;
    color: #fff;
    box-shadow: none;
}

.btn-upload,
.btn-salvar {
    margin: 0;
}

/*Also*/
.fileinput-button input {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
    opacity: 0;
    -ms-filter: 'alpha(opacity=0)';
    filter: 'alpha(opacity=0)';
    font-size: 200px;
    direction: ltr;
    cursor: pointer;
}

.img-preview {
    max-width: 100%;
    height: 500px;
}
</style>
